<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" :fill="fillColor">
    <g>
      <path
        d="M10.77,18.3a7.53,7.53,0,1,1,7.53-7.53A7.53,7.53,0,0,1,10.77,18.3Zm0-13.55a6,6,0,1,0,6,6A6,6,0,0,0,10.77,4.75Z"
      />
      <path
        d="M20,20.75a.74.74,0,0,1-.53-.22L15.34,16.4a.75.75,0,0,1,1.06-1.06l4.13,4.13a.75.75,0,0,1,0,1.06A.74.74,0,0,1,20,20.75Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    fillColor: {
      type: String,
      required: false,
    },
  },
};
</script>
